import api from "src/services/api";

export type MisAsignacionesResponse = {
  asignaciones: any[];
  ordenes_servicio: any[];
  reemplazos: any[];
  limpiezas_profundas: any[];
  // Novedades del calendario Contact Center: refuerzo, dia libre, vacaciones, permiso
  novedades_cc: any[];
};

const MisAsignacionesService = {
  // fecha opcional en formato YYYY-MM-DD: trae lo vigente en esa fecha (hoy, futuro o pasado).
  // Sin fecha: comportamiento por defecto del backend (vigente desde hoy).
  async listar(fecha?: string): Promise<MisAsignacionesResponse> {
    const qs = fecha ? `?fecha=${encodeURIComponent(fecha)}` : "";
    const { data } = await api.get(`asignacion/mis_asignaciones${qs}`);
    return (data?.datos || data) as MisAsignacionesResponse;
  },
};

export default MisAsignacionesService;
